export type Bonus = {
  number: string
  title: string
  body: string
  tag: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The Rookie Coach Primer',
    body: "Never played, or haven't touched a football in years? Learn the positions, the words coaches use and the rules that matter for kids' football — in one evening, in plain English.",
    tag: 'bg-q1',
    image: 'https://cdn.magicpatterns.com/uploads/xmHDgQdS8vi1hkukJSF72x/mockup-the-rookie-coach-primer.png',
  },
  {
    number: '02',
    title: 'The Master Card Index',
    body: 'All 142 Practice Cards on one clipboard. A one-line summary of every card, sorted by skill, format and level, so you find tomorrow’s practice in 30 seconds — without opening a file.',
    tag: 'bg-q3',
    image: 'https://cdn.magicpatterns.com/uploads/1zYXZ8Xbet2Uqfac9wNdrP/mockup-the-master-card-index.png',
  },
  {
    number: '03',
    title: 'The Every-Player Awards Pack',
    body: '30 printable awards built around effort, character and skill, so every player on your roster gets one that fits them — not a generic participation sheet.',
    tag: 'bg-q2',
    image: 'https://cdn.magicpatterns.com/uploads/bhT4ys9r6n5YC4ftSkR31q/mockup-the-every-player-awards-pack.png',
  },
  {
    number: '04',
    title: 'The Parent Message Pack',
    body: 'Copy-paste messages for every parent moment of the season: the welcome text, schedule changes, weather calls, playing-time questions and the end-of-season thank-you.',
    tag: 'bg-turf',
    image: 'https://cdn.magicpatterns.com/uploads/u2fuhgWzP5aELyWBSNk8vp/mockup-the-parent-message-pack.png',
  },
  {
    number: '05',
    title: 'The Attention Toolkit',
    body: 'What to do the moment you lose the group. 25 attention resets under 30 seconds, a team-rules poster the kids help write, and what to say when a player gets upset.',
    tag: 'bg-q4',
    image: 'https://cdn.magicpatterns.com/uploads/1Mj15onXiRDxDQ967fhkLJ/mockup-the-attention-toolkit.png',
  },
]
